import { render, staticRenderFns } from "./LeaveListing.vue?vue&type=template&id=1f55b0da&scoped=true"
import script from "./LeaveListing.vue?vue&type=script&lang=js"
export * from "./LeaveListing.vue?vue&type=script&lang=js"
import style0 from "./LeaveListing.vue?vue&type=style&index=0&id=1f55b0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55b0da",
  null
  
)

export default component.exports